module.exports = __webpack_public_path__ + "static/media/pay-by-allinpay.fc725da2.png";